export const MAP_GEOLOCATION_ZOOM = 18;
